<template>
  <div>
    <el-drawer
      :title="title"
      :visible.sync="drawer"
      size="80%"
      :wrapperClosable="false"
    >
      <div class="div" v-loading="loading">
        <div class="div-top">
          <el-button
            icon="el-icon-minus"
            type="danger"
            @click="handleDetele(selectedRows)"
            :disabled="selectedRows.length === 0"
            >删除</el-button
          >
          <el-input
            v-model="searchData.Keyword"
            placeholder="请输入设备名称"
            clearable
            style="width: 300px; margin-left: 10px"
          ></el-input>
          <el-button
            type="primary"
            @click="handleSearch"
            style="margin-left: 10px"
            >查询</el-button
          >
          <el-button
            type="primary"
            @click="handleSearch"
            style="margin-left: 10px"
            >刷新</el-button
          >
        </div>
        <div class="div-center">
          <el-table
            :data="tableData"
            ref="table"
            style="width: 100%"
            height="calc(100% - 40px)"
            @selection-change="handleSelect"
          >
            <el-table-column
              label=""
              width="50"
              type="selection"
              :selectable="selectable"
            >
            </el-table-column>
            <el-table-column label="序号" width="50" type="index">
            </el-table-column>

            <!-- <el-table-column label="仓库" align="center" prop="StorIdName"> </el-table-column> -->
            <el-table-column label="设备原编号" align="center" prop="device_no">
            </el-table-column>
            <el-table-column label="设备编号" align="center" prop="DeviceCode">
            </el-table-column>
            <el-table-column label="设备名称" align="center" prop="device_name">
            </el-table-column>
            <el-table-column
              label="设备型号"
              align="center"
              prop="model_number"
            >
            </el-table-column>
            <el-table-column
              label="设备规格"
              align="center"
              prop="specification"
            >
            </el-table-column>
            <el-table-column
              label="生产厂家名称"
              align="center"
              prop="manufacturer"
            >
            </el-table-column>
            <el-table-column
              label="购置价格"
              align="center"
              prop="purchase_price"
            >
            </el-table-column>
            <el-table-column label="设备数量" align="center" prop="Num">
            </el-table-column>
            <el-table-column
              label="接收状态"
              align="center"
              prop="ReceiveStatus"
            >
              <template slot-scope="scope">
                <el-tag v-if="scope.row.ReceiveStatus === 0">未接收</el-tag>
                <el-tag v-else-if="scope.row.ReceiveStatus === 1" type="success"
                  >已接收</el-tag
                >
              </template>
            </el-table-column>
            <el-table-column label="操作" width="150">
              <template slot-scope="scope">
                <el-button
                  v-if="scope.row.ReceiveStatus === 0"
                  type="text"
                  @click="handleDetele([scope.row])"
                  style="color: #f78989"
                  >还原</el-button
                >
              </template>
            </el-table-column>
          </el-table>
          <div
            style="
              height: 40px;
              display: flex;
              align-items: center;
              justify-content: right;
            "
          >
            <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="pagination.PageIndex"
              :page-sizes="pagination.PageSizes"
              :page-size="pagination.PageRows"
              layout="total, sizes, prev, pager, next, jumper"
              :total="pagination.total"
            >
            </el-pagination>
          </div>
        </div>
      </div>
    </el-drawer>
  </div>
</template>
<script>
export default {
  data() {
    return {
      drawer: false,
      searchData: {
        Keyword: '',
      },
      tableData: [],
      pagination: {
        PageIndex: 1,
        PageRows: 20,
        PageSizes: [20, 40, 60, 100],
        total: 0,
      },
      selectedRows: [],
      loading: false,
      title: '',
      rowId: '',
      rowCode: '',
    }
  },
  props: {},
  components: {},
  methods: {
    selectable(row) {
      return row.ReceiveStatus === 0
    },
    openList(title, id, code) {
      this.title = title
      this.drawer = true
      // if (id) {
      //   this.rowId = id;
      //   this.rowCode = code;
      this.getDataList()
      // }
    },
    handleSelect(selection) {
      this.selectedRows = selection
    },
    getDataList() {
      this.selectedRows = []
      this.loading = true
      this.$http
        .post('/Base_DeviceTreeManage/DeviceItem_Temp/GetDataList', {
          PageIndex: this.pagination.PageIndex,
          PageRows: this.pagination.PageRows,
          SortField: 'ReceiveStatus',
          SortType: 'Desc',
          Search: {
            Condition: 'device_name',
            Keyword: this.searchData.Keyword,
          },
          // TypeId: this.rowId,
        })
        .then((resJson) => {
          this.loading = false
          this.tableData = resJson.Data
          this.pagination.total = resJson.Total
          this.$nextTick(() => {
            if (this.$refs.table) {
              this.$refs.table.clearSelection()
            }
          })
        })
    },
    handleSearch() {
      this.pagination.PageIndex = 1
      this.getDataList()
    },
    handleCurrentChange(PageIndex) {
      this.pagination.PageIndex = PageIndex
      this.getDataList()
    },
    handleSizeChange(PageRows) {
      this.pagination.PageIndex = 1
      this.pagination.PageRows = PageRows
      this.getDataList()
    },
    handleAdd() {
      this.$refs.EditForm.openForm('新建规则', {
        TypeId: this.rowId,
      })
    },
    handleDetele(rows) {
      let ids = rows.map((item) => item.Id)
      this.$confirm(`此操作将还原改设备为未拆分状态, 是否继续?`, {
        type: 'warning',
      })
        .then(() => {
          this.loading = true
          this.$http
            .post('/Base_DeviceTreeManage/DeviceItem_Temp/DeleteData', ids)
            .then((resJson) => {
              this.loading = false
              if (resJson.Success) {
                this.$notify.success('还原成功')
                this.getDataList()
                this.$emit('refreshData', true)
              } else {
                this.$notify.error(resJson.Msg)
              }
            })
        })
        .catch(() => {})
    },
    handleEdit(row) {
      this.$refs.EditForm.openForm('编辑字典', row)
    },
  },
  mounted() {},
  created() {},
  computed: {},
  watch: {},
}
</script>
<style lang="scss" scoped>
.div-top,
.div-search {
  // height: 30px;
  line-height: 30px;
}
.div-search {
  margin-top: 10px;
}
.div-center {
  margin-top: 10px;
  height: calc(100% - 30px);
}
.title {
  font-size: 20px;
  font-weight: bold;
  line-height: 40px;
}
::v-deep .el-drawer__header {
  margin: 0;
  padding: 20px;
  font-weight: bold;
  font-size: 20px;
}
</style>
